import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import Voicemail from 'components/broker/Voicemail';
import moment from 'moment-timezone';

const useStyles = makeStyles((theme) => ({
	root: {
		marginBottom: theme.spacing(2),
	},
	header: {
		cursor: 'pointer',
	},
}));

function Notes(props) {
	const classes = useStyles();
	const { lead } = props;
	const [showContent, setShowContent] = useState(false);

	let items = [];

	for (var note of lead.notes) {
		items.push({ category: 'note', label: 'Note', timestamp: note.createdAt, note: note });
	}

    items.sort((a, b) => {
		return new Date(b.timestamp) - new Date(a.timestamp)
	})

	return (
		<Card className={classes.root + ' notes-container'}>
			<CardHeader
				subheader={
					<Grid
						container
						component={Box}
						alignItems='center'
						justifyContent='space-between'
					>
						<Grid item xs='auto'>
							<Box
								component={Typography}
								variant='h3'
								marginBottom='0!important'
							>
								Notes
							</Box>
						</Grid>
						<Grid item xs='auto'>
							<Box>
								{showContent ? (
									<KeyboardArrowUp />
								) : (
									<KeyboardArrowDown />
								)}
							</Box>
						</Grid>
					</Grid>
				}
				onClick={() => setShowContent(!showContent)}
				style={{ cursor: 'pointer' }}
			/>
			{showContent && (
				<CardContent>
					{items.length > 0 ? (
						items.map((item, index) => (
							<Grid container key={index}>
								<Grid item xs={12}>
									{item.note.category === 'Voicemail' ? (
										<Voicemail vmKey={item.note.note} />
									) : (
										<p>{item.note.note}</p>
									)}
								</Grid>
								<Grid item xs={12}>
									<Grid container justifyContent='space-between'>
										<Grid item>
											{(!item.note.system && !props.admin) && (
												<p
													style={{ textAlign: 'left', fontSize: '0.75rem' }}
													className='hover-text'
													onClick={() => props.editNote(item.note)}
												>
													Edit
												</p>
											)}
										</Grid>
										<Grid item>
											<p
												style={{ textAlign: 'right', fontSize: '0.75rem' }}
											>
												{moment(item.note.createdAt).format('Do MMMM YYYY HH:mm')}
											</p>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						))
					) : (
						<Typography>No notes added</Typography>
					)}
				</CardContent>
			)}
		</Card>
	);
}

export default Notes;
